



















































































































































































































































import Vue from 'vue'
import { mapState } from 'vuex'

import ToolbarSave from '@/components/icons/toolbar-save.vue'
import ToolbarRefresh from '@/components/icons/toolbar-refresh.vue'
import ToolbarDelete from '@/components/icons/toolbar-delete.vue'

// import { Create, Delete, Patch } from '@/api/tags'
import { AlarmSetting, Create, Find, Delete, Patch } from '@/api/alarm'

interface SelectOptions {
  value: string | number
  text: string
}

export default Vue.extend({
  name: 'TableTag',
  props: {
    devices: Array,
  },
  components: {
    ToolbarSave,
    ToolbarRefresh,
    ToolbarDelete,
  },
  data() {
    return {
      //----------------------------------------------------------------------------------------------------
      // Options
      //----------------------------------------------------------------------------------------------------
      optsDataType: [
        { value: 'bool', text: 'Boolean' },
        { value: 'int8', text: 'Short' },
        { value: 'uint8', text: 'Unsigned short' },
        { value: 'int16', text: 'Integer' },
        { value: 'uint16', text: 'Unsigned integer' },
        { value: 'int32', text: 'Long' },
        { value: 'uint32', text: 'Unsigned long' },
        { value: 'float32', text: 'Float 32' },
        { value: 'float64', text: 'Float 64' },
      ],
      optsCondition: [
        { text: 'Equal', value: '=' },
        { text: 'Not equal', value: '!=' },
        { text: 'Greather than', value: '>' },
        { text: 'Greather than equal', value: '>=' },
        { text: 'Lower than', value: '<' },
        { text: 'Lower than equal', value: '<=' },
      ] as SelectOptions[],

      optsClass: [
        { text: 'Error', value: 'error' },
        { text: 'Warning', value: 'warning' },
      ],

      alarms: [] as AlarmSetting[],

      newAlarm: {} as AlarmSetting,
      selectedAlarm: {} as AlarmSetting,
      selectedId: -1,
    }
  },

  computed: {
    ...mapState('tag', { tags: 'items' }),
    optsTags(): SelectOptions[] {
      const optsTags: SelectOptions[] = []
      for (const uid in this.tags) {
        optsTags.push({
          text: this.tags[uid].name,
          value: this.tags[uid].uid,
        })
      }

      return optsTags
    },
  },

  methods: {
    //-------------------------------------------------------------------------------------------------
    // Inisialisasi
    //-------------------------------------------------------------------------------------------------
    initNewRow() {
      this.newAlarm.id = 0
      this.newAlarm.text = ''
      this.newAlarm.tagUid = ''
      this.newAlarm.digitalAlarm = false
      this.newAlarm.condition = '='
      this.newAlarm.value = 0
      this.newAlarm.threshold = 0
      this.newAlarm.class = 'error'
      this.newAlarm.notifComing = true
      this.newAlarm.notifAck = true
      this.newAlarm.notifGoing = true
    },

    //-------------------------------------------------------------------------------------------------
    // Database operations
    //-------------------------------------------------------------------------------------------------
    async create(alarm: AlarmSetting) {
      await Create(alarm)
    },
    async find() {
      this.alarms = await Find()
    },

    async patch(id: number, alarm: AlarmSetting) {
      await Patch(id, alarm)
    },

    async delete(id: number) {
      await Delete(id)
    },

    //-------------------------------------------------------------------------------------------------
    // Event pada mouse & keyboard
    //-------------------------------------------------------------------------------------------------
    onRowClicked(alarm: AlarmSetting) {
      this.selectedId = alarm.id
      this.selectedAlarm = alarm
    },
    onRowContextMenu(alarm: AlarmSetting) {
      this.selectedId = alarm.id
      this.selectedAlarm = alarm
    },

    async onRowEnterKeyUp(alarm: AlarmSetting) {
      await this.patch(alarm.id, alarm)
      await this.find()
    },

    async onNewRowEnterKeyUp() {
      await this.create(this.newAlarm)
      this.initNewRow()
      await this.find()
    },

    //-------------------------------------------------------------------------------------------------
    // Toolbar
    //-------------------------------------------------------------------------------------------------

    onToolbarRefresh() {
      this.find()
    },

    async onToolbarSave() {
      if (this.selectedId == -1) return

      await this.patch(this.selectedId, this.selectedAlarm)
    },

    /**
     * Tampilkan dialog konfirmasi penghapusan tag ketika tombol delete pada toolbar di-klik
     * jika selectedId bukan -1
     */
    onToolbarDelete() {
      if (this.selectedId == -1) {
        return
      }

      // eslint-disable-next-line
      ;(this as any).$refs.dialogDelete.show()
    },

    //-------------------------------------------------------------------------------------------------
    // Dialogs
    //-------------------------------------------------------------------------------------------------
    async onDialogDeleteOk() {
      await this.delete(this.selectedId)
      await this.find()
    },
  },

  watch: {
    /**
      Pantau perubahan selectedId.
      Jika selectedId berubah, trigger even onSelectedIdChanged dan kirimkan id baru sebagai payload.
     */
    selectedId: function(value: number) {
      this.$emit('onSelectedIdChanged', value)
    },

    selectedAlarm: function(value: AlarmSetting) {
      this.$emit('selectedChanged', value)
    },
  },

  async created() {
    await this.find()
  },
})
